import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/winesInStock'
import Content from './grid'

import { urls } from 'urls'

const PAGE = 'winesInStock'

export const metadata = {
  icon: 'archive',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE],
  hideCreate: true
}

const WinesInStockPage = createListPage({ metadata, api, actionCreators, Content })

export { WinesInStockPage }
